import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApplicationSettings } from 'lib-config';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { JurisdictionObligationOption } from '../models/master-data/jurisdiction-obligation-option.model';

@Injectable({
  providedIn: 'root'
})
export class JurisdictionObligationOptionService { //Todo: This service might need to be moved to a diffrent location

  constructor(private http: HttpClient, public settings: ApplicationSettings) { }

  getJurisdictionObligationOptions(filter: string): Observable<JurisdictionObligationOption[]> {
    let result = this.http.get<JurisdictionObligationOption[]>('assets/dummy-json/jurisdiction-obligation-option-list.json');
    return this.filterResult(result, filter);
  }

  private filterResult(observable: Observable<JurisdictionObligationOption[]>, filter: string): Observable<JurisdictionObligationOption[]>{
    observable = this.filter(observable, x => (!this.settings.production || !((<any>x).isTestingOnly)) && (this.settings.enableDevTools || !((<any>x).isDevToolEnabled)));
    if (filter) {
      observable = this.filter(observable, x => x.name.includes(filter) || x.code.includes(filter));
    }

    return observable;
  }

  private filter(observable: Observable<JurisdictionObligationOption[]>, filterFunc: (x:JurisdictionObligationOption) => boolean): Observable<JurisdictionObligationOption[]>{
    return observable.pipe(map(JurisdictionObligationOption => JurisdictionObligationOption.filter(filterFunc)));
  }
}
